import type { LinkTarget } from "../../aysa_api/models/link_target.types";
import { Reader, Writer } from "protobufjs/minimal";

export const createBaseLinkTarget = (): LinkTarget => {
  return {
    url: "",
    external: false,
  };
};

export const decodeLinkTarget = (
  reader: Reader,
  length: number
): LinkTarget => {
  const end = reader.pos + length;
  const message = createBaseLinkTarget();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.url = reader.string();

        break;
      case 2:
        message.external = reader.bool();

        break;
      case 3:
        message.canonicalUrl = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeLinkTarget = (
  writer: Writer,
  message: LinkTarget
): Writer => {
  writer.uint32(10).string(message.url);
  writer.uint32(16).bool(message.external);
  if (message.canonicalUrl !== undefined) {
    writer.uint32(26).string(message.canonicalUrl);
  }

  return writer;
};
